import {
    ProductSearchResult,
    SimpleProduct,
    ProductPrice,
    ProductWarehouseInventoryInformation,
    AttributeValue
} from '@msdyn365-commerce/retail-proxy';
import {
    getAttributeValuesAsync,
    getByIdsAsync,
    searchByCategoryAsync,
    getActivePricesAsync,
    getEstimatedAvailabilityAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { IEcommProductCartDataSet } from './components-interfaces-definition';
import { IEcommProductDetailsFormData } from '../ecomm-product-details-form.data';
import { IEcommProductDetailsFormProps } from '../ecomm-product-details-form.props.autogenerated';

export async function getProductServiceObjects(
    props: IEcommProductDetailsFormProps<IEcommProductDetailsFormData>,
    categoryId: number
): Promise<IEcommProductCartDataSet> {
    const { context } = props;
    const projectDomain = {
        ChannelId: +context.actionContext.requestContext.apiSettings.channelId,
        CatalogId: +context.actionContext.requestContext.apiSettings.catalogId
    };

    const productObject: SimpleProduct = await props.data.product;
    //let productSearchResult: ProductSearchResult[];
    //let productSearchResultFiltered: ProductSearchResult[];
    let productsAvailabilityResults: ProductWarehouseInventoryInformation = {};
    let attributesList: AttributeValue[] = [];
    let simpleProductsResults: SimpleProduct[] = [];
    let activePricesResult: ProductPrice[] = [];
    const productIds: number[] = [];
    let resultObject: IEcommProductCartDataSet = {};

    const productSearchResult: ProductSearchResult[] = await searchByCategoryAsync(
        { callerContext: context.actionContext },
        context.request.apiSettings.channelId,
        context.request.apiSettings.catalogId,
        categoryId
    );
    productIds.push(productObject.RecordId);
    const productSearchResultFiltered: ProductSearchResult[] = productSearchResult.filter(elem => {
        return elem.RecordId === productObject.RecordId;
    });

    if (productSearchResultFiltered) {
        simpleProductsResults = await getByIdsAsync(
            { callerContext: context.actionContext },
            context.request.apiSettings.channelId,
            productIds
        );
        activePricesResult = await getActivePricesAsync(
            { callerContext: context.actionContext, queryResultSettings: {} },
            projectDomain,
            productIds,
            new Date(),
            null,
            [],
            true
        );
        productsAvailabilityResults = await getEstimatedAvailabilityAsync(
            { callerContext: context.actionContext },
            { ProductIds: productIds, DefaultWarehouseOnly: true }
        );
        attributesList = await getAttributeValuesAsync(
            { callerContext: context.actionContext },
            productIds[0],
            context.request.apiSettings.channelId,
            context.request.apiSettings.catalogId
        );
    }

    resultObject = {
        productIds: productIds,
        attributesList: attributesList,
        selectedProducts: productSearchResultFiltered,
        productsSimpleDetails: simpleProductsResults,
        activePrices: activePricesResult,
        productsAvailability:
            productsAvailabilityResults && productsAvailabilityResults.ProductWarehouseInventoryAvailabilities
                ? productsAvailabilityResults.ProductWarehouseInventoryAvailabilities
                : undefined
    };

    return resultObject;
}
